import React, { Component } from 'react'

import PropTypes from 'prop-types'

import numberConverter from '../../../../../utils/tuition/numberForCurrency'

import ResultCaret, { caretOrientations } from './components/ResultCaret'

export default class ViewAverageSalary extends Component {
  static propTypes = {
    description: PropTypes.any,
    predictedSalary: PropTypes.any.isRequired,
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    isMobile: PropTypes.bool.isRequired,
    yearsToPosition: PropTypes.any.isRequired,
  }
  render() {
    const { description, predictedSalary, onClick, isActive, isMobile } = this.props
    return (
      <div style={{ padding: 10 }}>
        <div
          className={`view-div salary ${isActive ? 'shadow' : ''}`}
          onClick={onClick}
          style={{
            borderRadius: '0.25rem',
            backgroundColor: isActive ? '#EFF5FC' : '',
            padding: 10,
            marginRight: isMobile ? 15 : 0,
          }}
        >
          <h6 className="color-blue">Salary</h6>
          <h6 style={{ height: '2.5em', marginBottom: 0 }}>Annual Average</h6>
          <h2
            className="color-green mb-0 text-center"
            style={{ fontSize: 40 }}
            title="Annual Salary"
          >
            <sup className="text-muted" style={{ fontSize: 25 }}>
              $
            </sup>
            {numberConverter(predictedSalary)}
          </h2>
          <p
            className="text-muted"
            style={{ margin: '-5px auto', fontSize: 12, textAlign: 'center' }}
          >
            {description}
          </p>
          {!isMobile && (
            <div style={{ paddingRight: 10 }} className="card-click-icon">
              <ResultCaret activeOrientation={caretOrientations.down} active={isActive} />
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/ViewAverageSalary.js